import React from 'react'
import styled from 'styled-components'
import { ReactComponent as FilterIcon } from '../../../../assets/accordion-arrow.svg'

const Container = styled.div`
  position: relative;
  border: 1px solid #ff5e6d;
  box-sizing: border-box;
  border-radius: 34px;
  font-size: 11px;
  cursor: pointer;
  outline: none;
  user-select: none;
  background: ${props => (props.active === true ? '#ff5e6d' : 'white')};
  color: ${props => (props.active === true ? 'white' : '#ff5e6d')};
`

const InnerContainer = styled.div`
  height: 30px;
  padding-left: 10px;
  padding-right: 10px;
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-self: center;
  font-size: 11px;
  cursor: pointer;
  outline: none;
`

const Title = styled.div`
  flex: 1 1 auto;
  overflow: hidden;
  white-space: nowrap;
  padding-right: 12px;
`

const IconContainer = styled.div`
  flex: 0 0 8px;
`

const Filter = styled(FilterIcon)`
  stroke: ${props => (props.active === 'true' ? 'white' : '#ff5e6d')};
  width: 10px;
`

const FilterSelections = ({ show, onClick }) => {
  const handleMenu = e => {
    const st = !show
    if (onClick) onClick(st)
  }

  return (
    <Container active={show === true ? true : false}>
      <InnerContainer onClick={handleMenu}>
        <Title>Catalog</Title>
        <IconContainer>
          <Filter active={show === true ? 'true' : 'false'} />
        </IconContainer>
      </InnerContainer>
    </Container>
  )
}

export default FilterSelections
